import { ChangeEvent, FC, useCallback, useState } from 'react';

import TextField, { TextFieldProps } from '@mui/material/TextField';
import { debounce } from 'lib';

type Props = TextFieldProps & {
  debounceTime?: number;
};

const DebouncedTextField: FC<Props> = props => {
  const {
    debounceTime = 300,
    value = '',
    onChange = () => {},
    ...rest
  } = props;
  const [inputValue, setInputValue] = useState(value);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;

      setInputValue(value);

      debounce(() => {
        onChange(event);
      }, debounceTime);
    },
    [debounceTime, onChange]
  );

  return <TextField value={inputValue} onChange={handleChange} {...rest} />;
};

export default DebouncedTextField;
